<template>
  <b-container fluid class="playbook-video-section">
    <b-row>
      <b-col>
        <b-card no-body>
          <b-tabs vertical v-model="slide">
            <b-tab
              v-for="(video, i) in videos"
              :key="i + 1"
              :title="video.id + 1 + '. ' + video.title"
              title-link-class="playbook-tabs"
              :active="video.id === slide"
              content-class="test"
              @click="logClick(video)"
              ><b-card-text align="center"> </b-card-text>
            </b-tab>
            <b-tab
              v-if="!hideMoreToCome"
              :title="this.$t('PLAYBOOK.moreToCome')"
              title-link-class="playbook-tabs"
              title-item-class="more-to-come"
              content-class="test"
              disabled
              ><b-card-text align="center"> </b-card-text>
            </b-tab>
            <h2 class="text-center">
              {{ this.slide + 1 }}. {{ videos[this.slide].title }}
            </h2>
            <div class="carousel-container">
              <b-carousel
                id="carousel-1"
                v-model="slide"
                :interval="7000"
                :controls="videos.length > 1"
              >
                <b-carousel-slide
                  class="carousel-slide"
                  v-for="video in videos"
                  :key="video.id"
                  img-blank
                  img-height="315"
                  img-width="560"
                >
                  <template #img>
                    <div class="video-wrapper">
                      <iframe
                        width="560"
                        height="315"
                        :src="video.src"
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </template>
                </b-carousel-slide>
              </b-carousel>
            </div>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "PlaybookSectionVideos",
  props: {
    videos: Array,
    hideMoreToCome:Boolean,
    videoGroup: String
  },
  mounted() {
    if (this.$route.query && this.$route.query.v) {
      const videoID = Number(this.$route.query.v);
      if(videoID && videoID<this.videos.length){
        this.slide = Number(this.$route.query.v);
      }
    }
    const arrowPrev = document.querySelector(".carousel-control-prev")
    const arrowNext = document.querySelector(".carousel-control-next")

    if (arrowPrev && arrowNext) {
      arrowPrev.addEventListener("click", () => {
        this.$amplitude.logEvent('pwa: click on playbook carousel', {arrow: "PREVIOUS"})
      })
      arrowNext.addEventListener("click", () => {
        this.$amplitude.logEvent('pwa: click on playbook carousel', {arrow: "NEXT"})
      })
    }
  },
  data: function () {
    return {
      slide: 0,
    };
  },
  methods: {
    goToSlide: function (slideNum) {
      this.slide = slideNum;
    },
    logClick: function (video) {
      this.$amplitude.logEvent('pwa: click on playbook video', {videoGruop: this.videoGroup, videoNumber: video.id + 1})
    }
  },
};
</script>

<style lang="scss">
.playbook-video-section {
  padding-top: 50px;

  .more-to-come{
    margin-top:23%;
    text-align: center;
  }
  h2 {
    color: #f68d2e;
    text-transform: uppercase;
    margin-bottom: 50px;
  }

  .carousel-control-next {
    right: -4%;
  }

  .carousel-control-prev {
    left: -4%;
  }

  .card {
    background-color: transparent;
  }
  .col-auto {
    border-right: 1px solid #5e5e62;
    width: 35%;
    .playbook-tabs {
      color: #5e5e62;
      cursor: pointer;
      font-size: 18px;
      font-weight: 500;
      display: block;
      letter-spacing: 1px;

      &.active {
        background-color: #222224;
        color: #f68d2e;
        border-color: transparent;
        cursor: pointer;
      }

      &:hover,
      &:focus,
      &:focus-visible {
        border-color: transparent;
        background-color: #222224;
        color: #f68d2e;
      }
    }

    .nav-tabs {
      border-bottom: none;
    }
  }

  .iframe-container {
    width: 75%;
    position: relative;
    height: 0;
    overflow: hidden;
    padding-top: 42%;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      max-width: 700px;
      min-width: 300px;
    }
  }
}

@media screen and (max-width: 992px) {
  .playbook-video-section {
    padding-top: 25px;
    .iframe-container {
      width: 100%;
      padding-top: 56.25%;
    }

    .col-auto {
      width: 100%;
      border-right: none;
      margin-top: 50px;
      text-align: center;
      order: 3;

      .playbook-tabs {
        display: inline-block;
      }
    }
  }
}

@media screen and (max-width: 420px) {
  .playbook-video-section {
    h2 {
      font-size: 25px;
    }

    .col-auto {
      .playbook-tabs {
        font-size: 14px;
      }
    }
  }
}
</style>